import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS, DEFAULT_HEADERS } from '../config/api';

// Crear instancia de axios
const httpClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: DEFAULT_HEADERS
});

console.log('🌐 HttpClient inicializado:');
console.log('📍 Base URL:', API_CONFIG.BASE_URL);
console.log('⏱️ Timeout:', API_CONFIG.TIMEOUT);
console.log('📋 Headers por defecto:', DEFAULT_HEADERS);

// Interceptor para requests - agregar token Sanctum automáticamente
httpClient.interceptors.request.use(
  (config) => {
    console.log('📤 HttpClient - Request interceptor:');
    console.log('🎯 Método:', config.method?.toUpperCase());
    console.log('🌐 URL completa:', `${config.baseURL}${config.url}`);
    console.log('📋 Headers antes:', config.headers);
    
    const token = localStorage.getItem(STORAGE_KEYS.JWT_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Token Sanctum agregado a headers');
    } else {
      console.log('⚠️ No hay token Sanctum en localStorage');
    }
    
    console.log('📋 Headers después:', config.headers);
    console.log('💾 Datos enviados:', config.data);
    
    return config;
  },
  (error) => {
    console.log('🚨 ERROR en request interceptor:', error);
    return Promise.reject(error);
  }
);

// Interceptor para responses - manejar errores y renovar tokens Sanctum
httpClient.interceptors.response.use(
  (response) => {
    console.log('📥 HttpClient - Response interceptor (SUCCESS):');
    console.log('🎯 Método:', response.config.method?.toUpperCase());
    console.log('🌐 URL:', `${response.config.baseURL}${response.config.url}`);
    console.log('📊 Status:', response.status);
    console.log('📄 Status Text:', response.statusText);
    console.log('📋 Response Headers:', response.headers);
    console.log('💾 Response Data:', response.data);
    
    return response;
  },
  async (error) => {
    console.log('🚨 HttpClient - Response interceptor (ERROR):');
    console.log('📍 Error name:', error.name);
    console.log('💬 Error message:', error.message);
    
    if (error.response) {
      console.log('📡 Response Error Details:');
      console.log('🔢 Status:', error.response.status);
      console.log('📄 Status Text:', error.response.statusText);
      console.log('💾 Response Data:', error.response.data);
      console.log('📋 Response Headers:', error.response.headers);
    } else if (error.request) {
      console.log('📡 Request Error (Sin respuesta del servidor):');
      console.log('🌐 Request:', error.request);
      console.log('⚠️ Posibles causas:');
      console.log('   - Servidor Laravel no está corriendo');
      console.log('   - Problema de CORS');
      console.log('   - Firewall bloqueando conexión');
      console.log('   - Red sin conexión');
    } else {
      console.log('⚙️ Error de configuración:', error.message);
    }

    const originalRequest = error.config;

    // Si el token ha expirado (401) y no hemos intentado renovarlo ya
    if (error.response?.status === 401 && !originalRequest._retry) {
      console.log('🔄 Token expirado (401) - Intentando renovar...');
      originalRequest._retry = true;

      try {
        // Intentar renovar el token
        const refreshToken = localStorage.getItem(STORAGE_KEYS.JWT_TOKEN);
        if (refreshToken) {
          console.log('🔄 Enviando petición de refresh token...');
          
          const response = await axios.post(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.AUTH.REFRESH}`,
            {},
            {
              headers: {
                ...DEFAULT_HEADERS,
                Authorization: `Bearer ${refreshToken}`
              }
            }
          );

          console.log('✅ Token renovado exitosamente');
          console.log('📥 Respuesta de refresh:', response.data);

          const { token } = response.data.authorization;
          localStorage.setItem(STORAGE_KEYS.JWT_TOKEN, token);

          // Reintentar la petición original con el nuevo token
          originalRequest.headers.Authorization = `Bearer ${token}`;
          console.log('🔄 Reintentando petición original con nuevo token...');
          
          return httpClient(originalRequest);
        } else {
          console.log('❌ No hay refresh token disponible');
        }
      } catch (refreshError) {
        console.log('🚨 ERROR al renovar token:', refreshError);
        
        // Si no se puede renovar el token, limpiar localStorage y redirigir al login
        localStorage.removeItem(STORAGE_KEYS.JWT_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.USER);
        localStorage.removeItem(STORAGE_KEYS.ROLES);
        localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
        localStorage.removeItem(STORAGE_KEYS.COMPANY);
        
        console.log('🧹 localStorage limpiado debido a error de refresh');
        console.log('🔄 Redirigiendo a login...');
        
        window.location.href = '/';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient; 